import {PersonalInformationApiModel} from "../../../../api/models/personal-information.api.model";
import {AbstractViewModel} from "../../../../core/interfaces/abstract-view-model";
import {CityViewModel} from "../../../../core/models/city.view-model";
import {CountryViewModel} from "../../../../core/models/country.view-model";
import {CityApiModel} from "../../../../api/models/city.api-model";
import {CountryApiModel} from "../../../../api/models/country.api-model";

export class PersonalInformationViewModel extends AbstractViewModel<PersonalInformationApiModel> {
  public firstName: string;
  public lastName: string;
  public phone: string;
  public address: string;
  public streetNr: string;
  public houseNr: string;
  public postcode: string;
  public province: string;
  public city: CityViewModel;
  public country: CountryViewModel;

  constructor(protected apiModel: PersonalInformationApiModel = new PersonalInformationApiModel()) {
    super(apiModel);
    this.fromApiModel(apiModel);
  }

  public fromApiModel(apiModel: PersonalInformationApiModel): this {
    this["@id"] = apiModel["@id"];
    this.firstName = apiModel.firstName;
    this.lastName = apiModel.lastName;
    this.phone = apiModel.phone;
    this.address = apiModel.address;
    this.streetNr = apiModel.streetNr;
    this.houseNr = apiModel.houseNr;
    this.postcode = apiModel.postcode;
    this.province = apiModel.province;
    if (typeof apiModel.city === 'string') {
      const cityApi = new CityApiModel();
      cityApi['@id'] = apiModel.city;
      this.city = new CityViewModel(cityApi);
    } else {
      this.city = apiModel.city ? new CityViewModel(apiModel.city as CityApiModel) : null;
    }
    if (typeof apiModel.country === 'string') {
      const countryApi = new CountryApiModel();
      countryApi['@id'] = apiModel.country;
      this.country = new CountryViewModel(countryApi);
    } else {
      this.country = apiModel.country ? new CountryViewModel(apiModel.country as CountryApiModel) : null;
    }
    return this;
  }

  public toApiModel(): PersonalInformationApiModel {
    const apiModel = this.apiModel;
    apiModel.firstName = this.firstName;
    apiModel.lastName = this.lastName;
    apiModel.phone = this.phone;
    apiModel.address = this.address;
    apiModel.streetNr = this.streetNr;
    apiModel.houseNr = this.houseNr;
    apiModel.postcode = this.postcode;
    apiModel.province = this.province;
    apiModel.city = this.city ? this.city['@id'] : null;
    apiModel.country = this.country ? this.country['@id'] : null;
    return apiModel;
  }

  public getFullName(): string {
    return this.firstName + ' ' + this.lastName;
  }
}
